import { createReducer, on } from "@ngrx/store";
import { EventHistoryState, initialEventHistoryState } from "./event-history.state";
import { GetAllEventTypes, GetAllEventTypesError, GetAllEventTypesSuccess, GetCurrentPageNumber, GetCurrentPageNumberError, GetCurrentPageNumberSuccess, GetEventHistoryRecordLength, GetEventHistoryRecordLengthError, GetEventHistoryRecordLengthSuccess, GetEventHistoryRecords, GetEventHistoryRecordsError, GetEventHistoryRecordsSuccess, UpdateEventHistoriesTable, UpdateEventHistoriesTableError, UpdateEventHistoriesTableSuccess } from "./event-history.action";

export const EventHistoryReducers = createReducer(
  initialEventHistoryState,
  on(GetAllEventTypes, (state): EventHistoryState => {
    return {
      ...state,
      allEventTypes: null,
      allEventTypesLoader: true,
      allEventTypesError: null,
    }
  }),
  on(GetAllEventTypesSuccess, (state, action): EventHistoryState => {
    return {
      ...state,
      allEventTypes: action.result,
      allEventTypesLoader: false,
      allEventTypesError: null,
    }
  }),
  on(GetAllEventTypesError, (state, action): EventHistoryState => {
    return {
      ...state,
      allEventTypesLoader: false,
      allEventTypesError: action.error,
    }
  }),
  on(GetEventHistoryRecords, (state): EventHistoryState => {
    return {
      ...state,
      eventHistoryLoader: true,
      eventHistoryError: null,
    }
  }),
  on(GetEventHistoryRecordsSuccess, (state, action): EventHistoryState => {
    return {
      ...state,
      eventHistoryRecords: action.result,
      eventHistoryLoader: false,
      updateEventHistoryTableLoader: false,
      eventHistoryError: null,
    }
  }),
  on(GetEventHistoryRecordsError, (state, action): EventHistoryState => {
    return {
      ...state,
      eventHistoryLoader: false,
      eventHistoryError: action.error,
    }
  }),
  on(GetCurrentPageNumber, (state): EventHistoryState => {
    return {
      ...state,
      currentPageNumber: 0,
      currentPageNumberLoader: true,
      currentPageNumberError: null,
    }
  }),
  on(GetCurrentPageNumberSuccess, (state, action): EventHistoryState => {
    return {
      ...state,
      currentPageNumber: action.result,
      currentPageNumberLoader: false,
      currentPageNumberError: null,
    }
  }),
  on(GetCurrentPageNumberError, (state, action): EventHistoryState => {
    return {
      ...state,
      currentPageNumberLoader: false,
      currentPageNumberError: action.error,
    }
  }),
  on(UpdateEventHistoriesTable, (state): EventHistoryState => {
    return {
      ...state,
      updateEventHistoryTable: null,
      updateEventHistoryTableLoader: true,
      updateEventHistoryTableError: null,
    }
  }),
  on(UpdateEventHistoriesTableSuccess, (state, action): EventHistoryState => {
    return {
      ...state,
      updateEventHistoryTable: action.result,
      updateEventHistoryTableLoader: false,
      updateEventHistoryTableError: null,
    }
  }),
  on(UpdateEventHistoriesTableError, (state, action): EventHistoryState => {
    return {
      ...state,
      updateEventHistoryTableLoader: false,
      updateEventHistoryTableError: action.error,
    }
  }),
  on(GetEventHistoryRecordLength, (state): EventHistoryState => {
    return {
      ...state,
      eventHistoryRecordsLengthLoader: true,
      eventHistoryRecordsLengthError: null
    }
  }),
  on(GetEventHistoryRecordLengthSuccess, (state, action): EventHistoryState => {
    return {
      ...state,
      eventHistoryRecordsLength: action.result,
      eventHistoryRecordsLengthLoader: false,
      eventHistoryRecordsLengthError: null
    }
  }),
  on(GetEventHistoryRecordLengthError, (state, action): EventHistoryState => {
    return {
      ...state,
      eventHistoryRecordsLengthLoader: false,
      eventHistoryRecordsLengthError: action.error,
    }
  }),
);